import { mergeMap } from "rxjs/operators";
import { SalesCompetitorService } from "./../../../services/settings-services/sales-competitor.service";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { of } from "rxjs";

@Component({
  selector: "app-add-territory-modal",
  templateUrl: "./add-territory-modal.component.html",
  styleUrls: ["./add-territory-modal.component.css"],
})
export class AddTerritoryModalComponent implements OnInit {
  @Output() emitData = new EventEmitter();
  territoryBy = "INDUSTRY";
  territorySelected;
  territoryList$;
  loading = false;
  assignedTerritories: any[];
  constructor(private salesCompSrv: SalesCompetitorService) { }

  ngOnInit() {
    this.getTerritoryBy();
  }
  closeModal() {
    this.loading = false;
    document.getElementById("closeTerritoyModal").click();
  }
  openModal(assignedTerritories = []) {
    document.getElementById("openAddTerritotyModal").click();
    this.territorySelected = assignedTerritories;
    this.assignedTerritories = assignedTerritories;
  }

  getTerritoryBy() {
    this.territorySelected = [];
    this.territoryList$ = this.salesCompSrv
      .getSalesTerritoriesByCategory(this.territoryBy)
      .pipe(
        mergeMap((data: any[]) => {
          const result = data.map((dat) => dat.name);
          // const result2 = this.arrDiff(result, ['Health'])
          return of(result);
        })
      );
  }

  arrDiff(array1: any[], array2: any[]): any[] {
    let result = array1.filter(function (obj) {
      return array2.indexOf(obj) == -1;
    });
    return result;
  }

  assign(value) {
    this.emitData.emit(value);
    this.loading = true;
  }
}
